import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input as CoreInput } from '@sparefoot/react-core';

import { Text } from 'components/core/Typography';

import './RadioInput.scss';

export function RadioInput({
	checked,
	label,
	id,
	onChange,
	type = 'radio',
	value,
	name,
	disabled = false,
}) {
	return (
		<label
			className={classnames('ss-label', `ss-${type}-input-label`)}
			htmlFor={id}
		>
			<CoreInput
				id={id}
				type={type}
				className={`ss-${type}-input`}
				onChange={onChange}
				checked={checked}
				value={value}
				name={name}
				disabled={disabled}
			/>
			<Text className="ss-label-text">{label}</Text>
		</label>
	);
}

RadioInput.propTypes = {
	checked: PropTypes.bool,
	label: PropTypes.node,
	id: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.string,
	type: PropTypes.string,
	disabled: PropTypes.bool,
};

export default RadioInput;
